"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _UICardWrapper = _interopRequireDefault(require("UIComponents/card/UICardWrapper"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _FormattedJSXMessage = _interopRequireDefault(require("I18n/components/FormattedJSXMessage"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

function TimelineCardError() {
  return _react.default.createElement(_UICardWrapper.default, {
    compact: true
  }, _react.default.createElement(_UIFlex.default, {
    align: "center",
    justify: "center",
    direction: "column",
    className: "p-y-8"
  }, _react.default.createElement(_UIIcon.default, {
    name: "warning",
    size: "medium",
    className: "m-bottom-2"
  }), _react.default.createElement(_FormattedJSXMessage.default, {
    message: "componentErrorAlert.timelineCardError_jsx",
    options: {
      href: window.location.href
    },
    elements: {
      Link: _UILink.default
    }
  })));
}

var _default = TimelineCardError;
exports.default = _default;
module.exports = exports.default;